import { useEffect, useState } from "react";
import { internalApi } from "../../api/internal";
import api from "../../auth/api"; // si no existe, cambia al path real

export default function ParticipantsModal({ open, onClose, threadId, canManage }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [allUsers, setAllUsers] = useState([]);
  const [pickUserId, setPickUserId] = useState("");
  const [pickRole, setPickRole] = useState("viewer");
  const [pickPost, setPickPost] = useState(false);
  const [pickManage, setPickManage] = useState(false);
  const [pickReply, setPickReply] = useState(false);

  async function load() {
    setLoading(true);
    try {
      const { data } = await internalApi.listParticipants(threadId);
      setRows(data?.rows || []);
    } catch (e) {
      alert(e?.response?.data?.error || "No se pudo cargar participantes");
    } finally {
      setLoading(false);
    }
  }

  async function loadUsers() {
    try {
      // Si ya tienes endpoint de users, úsalo.
      // Ejemplo genérico: GET /users?active=1
      const { data } = await api.get("/users", { params: { active: 1 } });
      setAllUsers(data?.rows || data?.users || []);
    } catch {
      setAllUsers([]);
    }
  }

  useEffect(() => {
    if (!open) return;
    load();
    loadUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, threadId]);

  if (!open) return null;

  const add = async () => {
    if (!pickUserId) return alert("Selecciona usuario");
    try {
      await internalApi.addParticipant(threadId, {
        user_id: Number(pickUserId),
        role: pickRole,
        can_post: pickPost ? 1 : 0,
        can_manage: pickManage ? 1 : 0,
        can_reply_customer: pickReply ? 1 : 0,
      });
      setPickUserId("");
      setPickRole("viewer");
      setPickPost(false); setPickManage(false); setPickReply(false);
      load();
    } catch (e) {
      alert(e?.response?.data?.error || "No se pudo agregar");
    }
  };

  const patch = async (userId, payload) => {
    try {
      await internalApi.patchParticipant(threadId, userId, payload);
      load();
    } catch (e) {
      alert(e?.response?.data?.error || "No se pudo actualizar");
    }
  };

  const del = async (userId) => {
    if (!window.confirm("¿Quitar participante?")) return;
    try {
      await internalApi.removeParticipant(threadId, userId);
      load();
    } catch (e) {
      alert(e?.response?.data?.error || "No se pudo quitar");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50">
      <div className="w-full max-w-3xl bg-white rounded-xl border border-slate-200 overflow-hidden">
        <div className="p-4 border-b flex items-center justify-between">
          <div className="font-semibold">Participantes</div>
          <button className="px-3 py-1.5 rounded-lg border" onClick={onClose}>Cerrar</button>
        </div>

        <div className="p-4">
          {canManage ? (
            <div className="bg-slate-50 border border-slate-200 rounded-xl p-3 mb-4">
              <div className="text-sm font-semibold mb-2">Agregar usuario</div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                <select className="px-3 py-2 rounded-lg border bg-white text-sm" value={pickUserId} onChange={(e) => setPickUserId(e.target.value)}>
                  <option value="">Selecciona usuario…</option>
                  {allUsers.map((u) => (
                    <option key={u.id} value={u.id}>
                      {u.name} ({u.role})
                    </option>
                  ))}
                </select>

                <select className="px-3 py-2 rounded-lg border bg-white text-sm" value={pickRole} onChange={(e) => setPickRole(e.target.value)}>
                  <option value="viewer">viewer</option>
                  <option value="agent">agent</option>
                  <option value="supervisor">supervisor</option>
                  <option value="owner">owner</option>
                </select>

                <button className="px-3 py-2 rounded-lg bg-slate-900 text-white text-sm" onClick={add}>
                  Agregar
                </button>
              </div>

              <div className="flex flex-wrap gap-3 mt-3 text-sm">
                <label className="flex items-center gap-2">
                  <input type="checkbox" checked={pickPost} onChange={(e) => setPickPost(e.target.checked)} />
                  can_post
                </label>
                <label className="flex items-center gap-2">
                  <input type="checkbox" checked={pickManage} onChange={(e) => setPickManage(e.target.checked)} />
                  can_manage
                </label>
                <label className="flex items-center gap-2">
                  <input type="checkbox" checked={pickReply} onChange={(e) => setPickReply(e.target.checked)} />
                  can_reply_customer
                </label>
              </div>
            </div>
          ) : null}

          {loading ? (
            <div className="text-slate-500">Cargando…</div>
          ) : (
            <div className="border border-slate-200 rounded-xl overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-slate-50">
                  <tr>
                    <th className="p-2 text-left">Usuario</th>
                    <th className="p-2">Role</th>
                    <th className="p-2">post</th>
                    <th className="p-2">manage</th>
                    <th className="p-2">reply</th>
                    <th className="p-2"></th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r) => (
                    <tr key={r.id} className="border-t">
                      <td className="p-2">
                        <div className="font-semibold">{r.name}</div>
                        <div className="text-xs text-slate-500">{r.email || ""}</div>
                      </td>
                      <td className="p-2 text-center">
                        {canManage ? (
                          <select
                            className="px-2 py-1 rounded border bg-white"
                            value={r.role}
                            onChange={(e) => patch(r.user_id, { role: e.target.value })}
                          >
                            <option value="viewer">viewer</option>
                            <option value="agent">agent</option>
                            <option value="supervisor">supervisor</option>
                            <option value="owner">owner</option>
                          </select>
                        ) : r.role}
                      </td>
                      <td className="p-2 text-center">
                        <input
                          type="checkbox"
                          checked={!!r.can_post}
                          disabled={!canManage}
                          onChange={(e) => patch(r.user_id, { can_post: e.target.checked ? 1 : 0 })}
                        />
                      </td>
                      <td className="p-2 text-center">
                        <input
                          type="checkbox"
                          checked={!!r.can_manage}
                          disabled={!canManage}
                          onChange={(e) => patch(r.user_id, { can_manage: e.target.checked ? 1 : 0 })}
                        />
                      </td>
                      <td className="p-2 text-center">
                        <input
                          type="checkbox"
                          checked={!!r.can_reply_customer}
                          disabled={!canManage}
                          onChange={(e) => patch(r.user_id, { can_reply_customer: e.target.checked ? 1 : 0 })}
                        />
                      </td>
                      <td className="p-2 text-right">
                        {canManage ? (
                          <button className="px-2 py-1 rounded border text-sm" onClick={() => del(r.user_id)}>
                            Quitar
                          </button>
                        ) : null}
                      </td>
                    </tr>
                  ))}
                  {!rows.length ? (
                    <tr><td className="p-3 text-slate-500" colSpan={6}>No hay participantes.</td></tr>
                  ) : null}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
